import React from 'react';
import { Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

const EmptyState = ({ icon, message, buttonText, onButtonClick }) => (
    <div style={{ textAlign: 'center', padding: 20 }}>
        {React.cloneElement(icon, { style: { fontSize: 24, color: '#bfbfbf' } })}
        <div style={{ marginTop: 8 }}>
            <Button type="dashed" icon={<PlusOutlined />} onClick={onButtonClick}>
                {buttonText}
            </Button>
        </div>
    </div>
);

export default EmptyState;